/**
 * Create React App entry point. This and `public/index.html` files can not be
 * changed or moved.
 */
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import axios from "axios";
import React from "react";
import ReactDOM from "react-dom";
import store, { persistor } from "./app/store/store";
import { setupAxios } from "./_metronic";
import App from "./App";
import "./index.scss"; // Standard version
// import "./sass/style.react.rtl.css"; // RTL version
import "socicon/css/socicon.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./_metronic/_assets/plugins/line-awesome/css/line-awesome.css";
import "./_metronic/_assets/plugins/flaticon/flaticon.css";
import "./_metronic/_assets/plugins/flaticon2/flaticon.css";

const { PUBLIC_URL } = process.env;

/**
 * Inject metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
setupAxios(axios, store);

const Layout = React.lazy(() => import("./_metronic/layout/Layout.js"));

ReactDOM.render(
  <App
    store={store}
    Layout={Layout}
    persistor={persistor}
    basename={PUBLIC_URL}
  />,
  document.getElementById("root")
);
